import { StyleSheet, Text, View, TouchableOpacity } from 'react-native'
import React from 'react'
import TableIcon from '../../icons/TableIcon'
import PullsIcon from '../../icons/PullsIcon'
import FowardFlatArrow from '../../icons/FowardFlatArrow'
import Colours from '../../utils/Colours'

const AccountsBodyScreen = () => {
  return (
    <View style={styles.accountsBodyContainer}> 
        <TouchableOpacity style={styles.profileDataContainer}>
        <View style={styles.profileDataSubContainer}>
             <TableIcon color={Colours.PRIMARY} height={25} width={25}/>
            <View style={styles.flatArrowContainer}>
            <Text style={{color:Colours.DARKGRAY, fontSize: 15, fontFamily:'Sen-Bold' }}>Socialite Account </Text>
            <FowardFlatArrow color={Colours.PRIMARY}/>
            </View>
        </View>
    </TouchableOpacity>

    <TouchableOpacity style={styles.profileDataContainer}
      onPress={()=>{}}
    >
        <View style={styles.profileDataSubContainer}>
             <PullsIcon color={Colours.PRIMARY}/>
            <View style={styles.flatArrowContainer}>
            <Text style={{color:Colours.DARKGRAY, fontSize: 15, fontFamily:'Sen-Bold' }}>Business Account </Text>
            <FowardFlatArrow color={Colours.PRIMARY}/>
            </View>
        </View>
    </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
    accountsBodyContainer:{
        backgroundColor: Colours.LIGHTEST,
        padding: 30,
        height:'100%'
    },
    profileDataContainer:{
        display: 'flex',
        backgroundColor: 'white',
        padding: 15,
        borderRadius: 10,
        marginBottom: 10,

    },
    profileDataSubContainer:{
        display: 'flex',
        flexDirection: 'row',
        gap: 10,
        alignItems: 'center'
    },
    flatArrowContainer:{
        display:'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
       // justifyContent: 'flex-end',
        // backgroundColor: Colours.MIDGRAY,
        width: 243,
    },

})

export default AccountsBodyScreen
